import { render, staticRenderFns } from "./AdminBusinessSection.vue?vue&type=template&id=87fc4c62"
import script from "./AdminBusinessSection.vue?vue&type=script&lang=js"
export * from "./AdminBusinessSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports